/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable eqeqeq */
import React, { useEffect, useState, useRef, useMemo } from "react";
import { withRouter } from "react-router";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Helmet } from "react-helmet";
import { Card, Label, FormGroup, NavItem, Nav, NavLink } from "reactstrap";
import { handleErrors } from "../../services/handleErrors";
import SpinnerButton from "../../components/Button";
import ConfirmModal from "./Tabs/ConfirmModal";
import { BlurSpinner } from "../../components/BlurSpinner";
import useFetcher from "../../hooks/useFetcher";
import AreasCard from "../../components/AreasCard";
import { fetchInfoGeneral, fetchInfoGeneralCategories, patchinfoGeneral } from "../../services/informacionGeneral";
import TablaProcedimiento from "./Procedimientos/tablaProcedimientos";
import { filterEnumSubAreas } from "./utils/filterEnumsSubarea";
import useQueryAsState from "../../hooks/useQueryAsState";
import Breadcrumb from "../../components/common/breadcrumb";
import Tabs from "./Tabs/Tabs";
import { fetchCliente } from "../../services/clientesServices";
import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";
import RelevoAdministrativo from "./RelevoAdministrativo";
import RelevoDePerfil from "./RelevoDePerfil";
import { TabStylesWraper } from "../../ui/TabStylesWraper";
import { LabSelect } from "../../components/course/select";
import RegistroDeVisitas from "./Visitas";

const InfoGeneral = () => {
  const { currentUser } = useAuth();
  const [client, setClient] = useState();
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.CLIENTES);
  const isAudit = currentUser && currentUser.haveAuditAccess(modulos.CLIENTES);
  const isOwner = client && client.isOwner;
  // eslint-disable-next-line max-len
  const [query, history] = useQueryAsState();
  const [infoGeneralCategories, isLoadingInfoGeneralCategories] = useFetcher(fetchInfoGeneralCategories, undefined, "fetchInfoGeneralCategories");
  const { clientId } = query;
  const [infoGeneralFullInfo, setInfoGeneralFullInfo] = useState();

  const activityComponent = useRef();
  const filesComponent = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const areaEnum = infoGeneralCategories == [] ? [] : infoGeneralCategories.area;
  const [subAreaEnum, setSubAreaEnum] = useState([]);
  // area y subAreas predefinidos
  const [selectArea, setSelectArea] = useState({
    id: 1,
    text: "Sucursal",
    csv: "sucursal",
  });
  const [subAreaSelected, setSubAreaSelected] = useState({ label: "Servicios", value: "servicios" });
  // toda la informacion obtenida de el filtro de area y subarea
  const [infoAreas, setInfoAreas] = useState();
  // informacion especifica de cada registro de informaciongeneral
  const [subAreaInformacion, setSubAreaInformacion] = useState({});
  // es el registro seleccionado de sub area (los nav en rojo)
  const [activeInfoSubArea, setActiveInfoSubArea] = useState(0);
  const [confirmarModal, setConfirmarModal] = useState(false);
  const [
    // changes,
    setChanges,
  ] = useState({ label: false, value: false });
  const sucursalOptionsTabs = ["Relevo Administrativo", "Relevo de Perfil"];
  const [activeOptionRelevo, setActiveOptionRelevo] = useState(0);
  const [selectedSeccion, setSelectedSeccion] = useState(1);
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // check in json if the area is editable
  const isSubAreaInformacionEditable = useMemo(() => {
    if (!subAreaInformacion || !infoGeneralCategories || !infoGeneralCategories.infoGeneralToCreateClient || !subAreaInformacion.area || !subAreaInformacion.subArea)
      return true;
    const infoGeneralData = infoGeneralCategories.infoGeneralToCreateClient.find(
      (i) => i.area === subAreaInformacion.area.csv && i.subArea === subAreaInformacion.subArea.csv && i.keyWord === subAreaInformacion.keyWord
    );
    return infoGeneralData && infoGeneralData.editable;
  }, [subAreaInformacion, infoGeneralCategories]);

  // maneja la seleccion de areas
  const handleAreaSelectChange = async (selected, data) => {
    setSelectedSeccion(selected.id);
    setIsLoading(true);
    const filterPerArea = async (dato) => {
      return dato.filter((r) => {
        if (r.area.csv === selected.csv) {
          return r;
        }
      });
    };
    const filterPerSubArea = async (dato, result) => {
      return dato.filter((r) => {
        if (r.subArea.csv == result[0].value) {
          return r;
        }
      });
    };
    const setFiltersAndData = async (result, encontradosPorSubArea) => {
      setInfoAreas(encontradosPorSubArea);
      setActiveInfoSubArea(0);
      setSubAreaEnum(result);
      setSubAreaSelected(result[0]);
      setSubAreaInformacion(encontradosPorSubArea[0] ? encontradosPorSubArea[0] : {});
    };
    if (!data) {
      const infoGeneralData = await fetchInfoGeneral(clientId);
      const result = await filterEnumSubAreas(infoGeneralData.result.rows, selected);
      const encontradosPorArea = await filterPerArea(infoGeneralData.result.rows);
      const encontradosPorSubArea = await filterPerSubArea(encontradosPorArea, result);
      await setFiltersAndData(result, encontradosPorSubArea);
      setInfoGeneralFullInfo(infoGeneralData.result.rows);
    } else {
      const result = await filterEnumSubAreas(infoGeneralFullInfo, selected);
      const encontradosPorArea = await filterPerArea(infoGeneralFullInfo, selected);
      const encontradosPorSubArea = await filterPerSubArea(encontradosPorArea, result);
      await setFiltersAndData(result, encontradosPorSubArea);
    }
    setIsLoading(false);
  };
  // maneja la seleccion de subAreas
  const handleSelectSubArea = async (subArea) => {
    const encontrados = infoGeneralFullInfo.filter((r) => {
      if (r.subArea.csv == subArea.value && r.area.csv == selectArea.csv) {
        return r;
      }
    });
    setSubAreaSelected(subArea);
    setInfoAreas(encontrados);
    setSubAreaInformacion(encontrados[0] ? encontrados[0] : {});
  };

  useEffect(async () => {
    if (!client || client.id != clientId) {
      const clientData = await fetchCliente(clientId);
      setClient(clientData);
      handleAreaSelectChange(selectArea, infoGeneralFullInfo);
    }
  }, [clientId]);

  // maneja la informacion de subAreas
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      text: subAreaInformacion.value == "" || subAreaInformacion.value == null ? "" : subAreaInformacion.value,
    },

    onSubmit: async (params) => {
      try {
        const body = {
          clientId,
          id: subAreaInformacion.id,
          value: params.text,
        };

        const res = clientId && params.text ? await patchinfoGeneral(clientId, body) : null;
        if (res) console.log("res", res); // no se usa res. Revisar si se puede eliminar

        handleAreaSelectChange(selectArea, undefined);
        setConfirmarModal(false);
        setChanges({ label: false, text: false });
        activityComponent.current.refreshActivities();
        setActiveInfoSubArea(0);
        toast.success("Registro actualizado");
      } catch (error) {
        handleErrors(error);
      }
    },
    validationSchema: Yup.object().shape({
      text: Yup.string().required(),
    }),
  });

  // Revisar si se puede eliminar
  // const handleBlur = (params) => {
  //   if (text) {
  //     if (formik.values[params] == text.value) {
  //       setChanges((prevState) => ({ ...prevState, [params]: false }));
  //     } else {
  //       setChanges((prevState) => ({ ...prevState, [params]: true }));

  //       return;
  //     }
  //   }
  // };
  const changeSubAreaInfo = (r) => {
    setSubAreaInformacion(r);
    formik.values.text = subAreaInformacion.value;
  };

  // No se usa. Revisar si se puede eliminar
  // const changeOptionRelevo = (r) => {
  //   setSubAreaInformacion(r);
  //   formik.values.text = subAreaInformacion.value;
  // };

  return (
    <BlurSpinner isLoading={isLoadingInfoGeneralCategories || isLoading}>
      <Helmet>
        <title>PIN - infoGeneral</title>
      </Helmet>
      <Breadcrumb title={client ? client.result.razonSocial : ""} parent="Información General" backButton className="pt-2 pb-0 w-100" />
      <div className="d-flex flex-column  pl-0 ml-2" style={{ fontFamily: "Nunito" }}>
        {/* cards de Area */}
        <div className="justify-content-between row col-12 w-100">
          {areaEnum
            ? areaEnum.type.map((r) => (
                <AreasCard
                  key={r.id}
                  text={r.text}
                  csv={r.csv}
                  select={selectArea.id == r.id}
                  onClick={() => {
                    setSelectArea(r);
                    handleAreaSelectChange(r, infoGeneralFullInfo);
                  }}
                />
              ))
            : ""}
        </div>

        <div className=" d-flex row justify-content-between col-12">
          {/* informacion de sub Areas "label" */}

          <div className="pl-0 col-9">
            <Card className="card-subArea p-2 w-100">
              {selectedSeccion === 1 ? null : (
                <Label htmlFor="Subarea" className="col-form-label  w-100 mb-2  z-index-3">
                  <h5>
                    <b> Subareas</b>
                  </h5>
                  <LabSelect
                    id="subArea"
                    name="subArea"
                    className="w-50 selectSubArea pl-0 mb-1"
                    style={{ zIndex: 2 }}
                    onChange={handleSelectSubArea}
                    value={subAreaSelected}
                    placeholder="Subáreas"
                    isClearable
                    autoFocus
                    options={
                      subAreaEnum
                        ? subAreaEnum.map((res) => {
                            return { label: res.label, value: res.value };
                          })
                        : []
                    }
                  />
                </Label>
              )}

              {selectedSeccion === 1 ? (
                <Nav tabs>
                  {sucursalOptionsTabs.map((r, index) => (
                    <NavItem>
                      <NavLink
                        className={index == activeOptionRelevo ? "nav_info_active-green" : "nav_info_notActive"}
                        active={index == activeOptionRelevo}
                        onClick={() => {
                          // changeSubAreaInfo(subAreaInformacion);
                          setActiveOptionRelevo(index);
                        }}
                      >
                        {r}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>
              ) : (
                <>
                  {infoAreas && (
                    <Nav tabs>
                      {infoAreas.map((r, index) => (
                        <NavItem key={r.id}>
                          <NavLink
                            className={index == activeInfoSubArea ? "nav_info_active-green" : "nav_info_notActive"}
                            active={index == activeInfoSubArea}
                            onClick={() => {
                              changeSubAreaInfo(r);
                              setActiveInfoSubArea(index);
                            }}
                          >
                            {r.keyWord}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>
                  )}
                </>
              )}

              {/* informacion de sub Areas "value" */}

              {selectedSeccion === 1 ? (
                <div className="m-auto w-100">
                  {activeOptionRelevo === 0 ? (
                    <RelevoAdministrativo clientId={clientId} history={history} isAudit={isAudit} />
                  ) : (
                    <RelevoDePerfil history={history} clientId={clientId} isAudit={isAudit} />
                  )}
                </div>
              ) : (
                <div className=" pl-0 pr-0 w-100 d-flex flex-row justify-content-between ">
                  {confirmarModal && <ConfirmModal toggle={() => setConfirmarModal(!confirmarModal)} handleSubmitArea={formik.handleSubmit} />}

                  <FormGroup className=" row justify-content-around align-items-end  w-100" style={{ margin: 0, zIndex: 1 }}>
                    <div className="form-group col-md-12 pl-0 pr-0 " style={{ margin: 0 }}>
                      <Label style={{ overflow: "auto", height: "35px", fontWeight: "600", fontSize: "0.8rem", paddingTop: "10px", letterSpacing: "normal" }}>
                        {subAreaInformacion.label}
                      </Label>
                      <textarea
                        className="subarea-registros form-control w-100 p-1"
                        id="text"
                        name="text"
                        cols="63"
                        value={formik.values.text}
                        onChange={formik.handleChange}
                        // onBlur={() => handleBlur("text")}
                        disabled={(!isAdmin && !isOwner) || !isSubAreaInformacionEditable || isAudit}
                      />
                      <div className="d-flex flex-row " style={{ height: "20px" }}>
                        {subAreaInformacion.value !== undefined && formik.values.text !== subAreaInformacion.value && subAreaInformacion.value !== null ? (
                          <div className="input-feedback">Cambios por guardar</div>
                        ) : (
                          <div />
                        )}
                        {subAreaInformacion.value !== undefined && formik.values.text === "" && subAreaInformacion.value !== "" && subAreaInformacion.value !== null ? (
                          <div className="input-feedback ml-2">No puede ingresar Texto Vacio</div>
                        ) : (
                          <div />
                        )}
                      </div>
                    </div>

                    <FormGroup className="mb-0 col-md-12  pr-0 w-25 d-flex flex-column  align-items-end">
                      {(isAdmin || isOwner) && isSubAreaInformacionEditable && (
                        <SpinnerButton
                          className="btn btn-success btn-sm mb-2"
                          style={{ fontSize: "0.8rem", textAlign: "center" }}
                          isLoading={false}
                          disabled={formik.values.text === ""}
                          onClick={() => setConfirmarModal(!confirmarModal)}
                        >
                          Guardar
                        </SpinnerButton>
                      )}
                    </FormGroup>
                  </FormGroup>
                </div>
              )}
            </Card>
            <Card className=" p-4  card-procedimiento w-100 ">
              <Nav tabs>
                <NavItem key="1">
                  <NavLink
                    className={activeTab === "1" ? "nav_info_active-green" : "nav_info_notActive"}
                    active={activeTab === "1"}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    Procedimientos
                  </NavLink>
                </NavItem>
                <NavItem key="2">
                  <NavLink
                    className={activeTab === "2" ? "nav_info_active-green" : "nav_info_notActive"}
                    active={activeTab === "2"}
                    onClick={() => {
                      toggleTab("2");
                    }}
                  >
                    Registro de Visitas
                  </NavLink>
                </NavItem>
              </Nav>

              {activeTab === "1" && <TablaProcedimiento clientId={clientId} isAdmin={isAdmin} isAudit={isAudit} isOwner={isOwner} filesComponent={filesComponent} />}
              {activeTab === "2" && <RegistroDeVisitas clientId={clientId} razonSocial={client ? client.result.razonSocial : ""} />}
            </Card>
          </div>
          {/* <div className="d-flex col-3 justify-content-center"> */}
          {/* <Card className="card-activity-infoGeneral card-body p-2 w-100"> */}
          <Card className="col-3">
            <TabStylesWraper>
              <Tabs
                clientId={clientId}
                isAdmin={isAdmin}
                isOwner={isOwner}
                isAudit={isAudit}
                entityId={infoAreas !== undefined && infoAreas[0] !== undefined ? infoAreas[0].id : undefined}
                activityComponent={activityComponent}
                filesComponent={filesComponent}
              />
            </TabStylesWraper>
          </Card>
          {/* </div> */}
        </div>
      </div>
    </BlurSpinner>
  );
};
export default withRouter(InfoGeneral);
